/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Row_Cy_BoatsInputs */

const es_marketplace_seo_license_row_cy_boats = /** @type {(inputs: Marketplace_Seo_License_Row_Cy_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin límite de eslora (recreo)`)
};

const gl_marketplace_seo_license_row_cy_boats = /** @type {(inputs: Marketplace_Seo_License_Row_Cy_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sen límite de eslora (recreo)`)
};

const en_marketplace_seo_license_row_cy_boats = /** @type {(inputs: Marketplace_Seo_License_Row_Cy_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No length limit (recreational)`)
};

/**
* | output |
* | --- |
* | "No length limit (recreational)" |
*
* @param {Marketplace_Seo_License_Row_Cy_BoatsInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_row_cy_boats = /** @type {((inputs?: Marketplace_Seo_License_Row_Cy_BoatsInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Row_Cy_BoatsInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_row_cy_boats(inputs)
	if (locale === "en") return en_marketplace_seo_license_row_cy_boats(inputs)
	return es_marketplace_seo_license_row_cy_boats(inputs)
});